import { render, staticRenderFns } from "./RenewalFrequency.vue?vue&type=template&id=31ca656a&scoped=true&"
import script from "./RenewalFrequency.vue?vue&type=script&lang=ts&"
export * from "./RenewalFrequency.vue?vue&type=script&lang=ts&"
import style0 from "./RenewalFrequency.vue?vue&type=style&index=0&id=31ca656a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca656a",
  null
  
)

export default component.exports